import { LocalityAddress } from 'app/model/LocalityAddress';

export class StreetAddress extends LocalityAddress {
    /**
     * (улица/проспект/...) (может отсутствовать)
     */
    streetType: string;

    /**
     * Название (может отсутствовать)
     */
    street: string;

    /**
     * Номер дома(может отсутствовать)
     */
    house: string;

    /**
     * Корпус (может отсутствовать)
     */
    building: string;

    /**
     * Квартира (может отсутствовать)
     */
    flat: string;

    /**
     * Почтовый индекс (может отсутствовать)
     */
    postalCode: string;

    constructor(
        soatoCode: string,
        countryCode: string,
        localityType: string,
        locality: string,
        region: string,
        district: string,
        villageCouncil: string,
        streetType: string,
        street: string,
        house: string,
        building: string,
        flat: string,
        postalCode: string,
    ) {
        super(
            soatoCode,
            countryCode,
            localityType,
            locality,
            region,
            district,
            villageCouncil,
        );
        this.streetType = streetType;
        this.street = street;
        this.house = house;
        this.building = building;
        this.flat = flat;
        this.postalCode = postalCode;
    }

    static deserialize(data: any) {
        return !!data
            ? new StreetAddress(
                  data.soatoCode,
                  data.countryCode,
                  data.localityType,
                  data.locality,
                  data.region,
                  data.district,
                  data.villageCouncil,
                  data.streetType,
                  data.street,
                  data.house,
                  data.building,
                  data.flat,
                  data.postalCode,
              )
            : null;
    }

    equals(other: StreetAddress): boolean {
        if (this === other) {
            return true;
        }
        if (!(other instanceof StreetAddress)) {
            return false;
        }
        const keys = Object.keys(this);
        for (const key of keys) {
            if (this[key as keyof this] !== other[key as keyof StreetAddress]) {
                return false;
            }
        }
        return true;
    }
}
